"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./index"));



//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/ng2-charts/ng2-charts.js
// module id = ../../../../ng2-charts/ng2-charts.js
// module chunks = 5